import { createSlice } from "@reduxjs/toolkit";

const orderSlice = createSlice({
  name: "order",
  initialState: {
    order: {},
    orderDetails: [],
  },
  reducers: {
    addOrderToState(state, action) {
      const newOrder = action.payload;

      state.order = newOrder;

      state.orderDetails.splice(
        0,
        state.orderDetails.length,
        ...newOrder.orderDetails
      );
      //   state.orderDetails = newOrder.orderDetails;
    },
  },
});

export const orderAction = orderSlice.actions;

export default orderSlice;
